﻿﻿export interface ITicketTag {
    id: number;
    tag: string;
}
